import { EditableColumnType } from '@aon/aon-tws-common-ui/build/lib/components/EditableTable';
import { FunctionComponent } from 'react';
import { connect } from 'react-redux';
import { IModalToggleButtonProps, TranslationEditorModule } from '../../components/translations/TranslationEditorModule';
import Constants from '../../constants';
import { ITranslationEditItem } from '../../models';
import { ITranslationApiParameters } from '../../services/TranslationsAPI';
import { IApplicationState } from '../../store';
import { setOpenedModalPopupName } from '../../store/SurveyContentItemsSlice';
import { ActionCreators } from '../../store/TranslationEditorStore';

export interface ITranslationEditorContainerProps {
	uniqueId: number;
	surveyId: number;
	property: string;
	propertyDisplayName: string;
	defaultTranslation: ITranslationEditItem;
	inputType: EditableColumnType;
	maxLength?: number;
	supportedCultures: string[];
	enableHtmlEditor: boolean;
	modalToggleButton?: FunctionComponent<IModalToggleButtonProps>;
	saveInModal?: boolean;
	notifyUpdate: (item: ITranslationEditItem) => void;
}

export const mapStateToProps = (state: IApplicationState, props: ITranslationEditorContainerProps) => {
	const instances = { ...state.translations.instances };
	const defaultCultureCode = state.survey.surveyEditModel.defaultCultureCode;
	const instance = instances[props.property] || {
		defaultCultureCode,
		loading: false,
		translations: [],
		lastSavedTranslations: [],
	};
	return { ...instance, defaultTranslation: { ...props.defaultTranslation, cultureCode: defaultCultureCode, language: '' } };
};

export const baseApi = Constants.API_TRANSLATIONS_URL + '/{surveyId}/{propertyName}';
export const getApiParameters = (props: ITranslationEditorContainerProps): ITranslationApiParameters => {
	const apiParams: ITranslationApiParameters = {
		apiUrl: baseApi.replace('{surveyId}', props.surveyId.toString()).replace('{propertyName}', props.property),
		uniqueId: props.uniqueId,
	};
	return apiParams;
};

export const mapDispatchToProps = (dispatch: any, props: ITranslationEditorContainerProps) => ({
	getTranslations: () => {
		dispatch(ActionCreators.getTranslations(props.property, getApiParameters(props)));
	},
	saveTranslations: (translations: ITranslationEditItem[]) => {
		dispatch(ActionCreators.saveTranslations(props.property, getApiParameters(props), translations));
	},
	updateTranslations: (translations: ITranslationEditItem[]) => {
		dispatch(ActionCreators.updateTranslations(props.property, translations));
	},
	notifyTranslationEditorModalOpen: () => {
		dispatch(setOpenedModalPopupName(props.property));
	},
	notifyUpdate: props.notifyUpdate,
});

export const TranslationEditorContainer: any = connect(mapStateToProps, mapDispatchToProps)(TranslationEditorModule);
